import React, { useState, useEffect } from "react";
import { sleep } from "./util";
import "./Word.scss";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions";

export default function Word(props) {
  const { disabled, hidden, onClick } = props;

  const word = props.children;
  let className = "intervention-word";
  if (word.length > 8) className += " longWord";
  if (disabled) className += " disabled";
  if (hidden) className += " hidden";
  if (props.className) className += ` ${props.className}`;

  return (
    <span
      className={className}
      id={props.id}
      style={props.style}
      {...doNotUseAccessibleStaticElementInteractions({onClick: onClick, onMouseEnter: onMouseEnter}) }
    >
      {renderWord()}
    </span>
  );

  function onMouseEnter(e) {
    if (props.onMouseEnter) props.onMouseEnter(e);
  }

  function renderWord() {
    const { underline } = props;

    // if part of word should be underlined
    if (underline) {
      const target = underline.toLowerCase();
      const tokenizedWord = word.toLowerCase().split(new RegExp(`(${target})`));
      let found = false;
      return tokenizedWord.map((token) => {
        if (token !== target || found) return token;
        found = true;
        return (
          <span className="underline" key={`token_${token}`}>
            {token}
          </span>
        );
      });
    }

    return word;
  }
}

export function Carousel(props) {
  const { words, underline, max = 3 } = props;

  const [index, setIndex] = useState(0);

  // increment index
  useEffect(() => {
    handleIndex();
  }, []);

  async function handleIndex() {
    for (let i = 0; i < max; i++) {
      setIndex(i);
      await sleep(3000);
    }
    props.onDone();
  }

  return <Word underline={underline}>{words[index]}</Word>;
}
